import React from "react";
import { motion } from "framer-motion";

const Breadcrumb = ({
  pageName,
  bgImage,
  parentPage,
}) => {
  return (
    <>
      <section
        className="breadcrumb-banner"
        style={{
          backgroundImage: `url(${bgImage})`,
        }}
      >

        {/* OVERLAY */}

        <motion.div
          className="breadcrumb-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
        ></motion.div>

        {/* CONTENT */}

        <div className="breadcrumb-content container">

          <div className="breadcrumb-left">

            {/* PATH */}

            <motion.p
              className="breadcrumb-path"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{
                duration: 0.6,
                delay: 0.2,
              }}
            >

              {/* HOME */}

              <motion.span
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.3 }}
              >
                Home
              </motion.span>

              {/* PARENT PAGE */}

              {parentPage && (
                <>
                  <span> › </span>

                  <motion.span
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ delay: 0.4 }}
                  >
                    {parentPage}
                  </motion.span>
                </>
              )}

              {/* CURRENT PAGE */}

              <span> › </span>

              <motion.span
                className="pg-name"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.5 }}
              >
                {pageName}
              </motion.span>

            </motion.p>

            {/* HEADING */}

            <motion.h1
              className="breadcrumb-heading"
              initial={{
                opacity: 0,
                y: 50,
                scale: 0.96,
              }}
              animate={{
                opacity: 1,
                y: 0,
                scale: 1,
              }}
              transition={{
                duration: 0.9,
                delay: 0.35,
                ease: [0.22, 1, 0.36, 1],
              }}
            >
              {pageName}
            </motion.h1>

          </div>

        </div>

      </section>
    </>
  );
};

export default Breadcrumb;